<template lang="html">

<div id="buildingVerificate">

  <div class="headLine">产业空间信息审核</div>

  <div class="navLine">
      <div v-for="(item,inx) in navArr" @click="navChange(inx)" :class="['navItem',{ 'act' : navAct == inx }]">{{item}}</div>
  </div>

  <div class="pgContent">
    <el-table border
        header-cell-class-name="dHead"
        v-loading="loading"
        :data="tbData">

        <el-table-column fixed="left" align="center" width="60" label="序号">
            <template slot-scope="scope">
                 {{ scope.$index + (params.no - 1)*params.size + 1 }}
            </template>
        </el-table-column>
        <el-table-column prop="buildingName" fixed="left" align="center" min-width="150" label="楼宇名称" />
        <el-table-column prop="tenement" align="center" width="120" label="物业单位" />
        <el-table-column prop="propertyUnit" align="center" min-width="120" label="产权单位" />
        <el-table-column prop="jiexiang" align="center" width="90" label="所在街乡" />
        <el-table-column prop="propertyUnit" align="center" min-width="150" label="地址" />
        <el-table-column prop="park" align="center" width="150" label="所属功能区" />
        <el-table-column prop="projectType" align="center" width="120" label="项目类型" />
        <el-table-column prop="nationalized" align="center" width="120" label="是否国有" />
        <el-table-column prop="location" align="center" width="120" label="产业定位" />
     
        <el-table-column prop="isWillingCityPlatformReleaseRecommend" align="center" width="150" label="是否愿意在市级平台对外发布推介" />
        <el-table-column prop="isWillingDistrictInvestmentWorkeleaseRecommend" align="center" width="120" label="是否愿意在区级招商工作中对外发布推介" />
        <el-table-column prop="notPublishReason" align="center" width="120" label="不希望对外发布的原因" />
        <el-table-column prop="isWillingUndertakeInterOrganizationWorkspace" align="center" width="120" label="是否愿意承接国际组织办公场所" />
        <el-table-column prop="planBuildingArea" align="center" width="120" label="规划建筑面积(平方米)" />
        <el-table-column prop="totalVacantArea" align="center" width="150" label="当前空置可招商面积(平方米)" />

        <el-table-column prop="leadingCadre" align="center" width="120" label="招商负责人" />
        <el-table-column prop="leadingCadrePhone" align="center" width="150" label="负责人手机号" />
        <el-table-column prop="leadingCadreEmail" align="center" width="120" label="负责人邮箱" />

        <el-table-column prop="uploadUser" align="center" width="90" label="上传用户" />
        <el-table-column prop="createdAt" align="center" width="180" label="上传时间" />
        <el-table-column prop="status" align="center" width="90" label="状态" fixed="right" style="white-space:pre-line;" >
                   <template slot-scope="scope">
                       {{ scope.row.status | statusTrans }}
                   </template>
               </el-table-column>
        <!-- 编辑 -->
        <el-table-column align="center" width="90" fixed="right" label="操作">
            <template slot-scope="scope">
                 <span v-if="scope.row.status == 2" @click="goInner(scope.row.id,1)" class="ibtn">查看</span>
                 <span v-else-if="scope.row.status == 1" @click="goInner(scope.row.id,2)" class="ibtn">审核</span>
                 <span v-else>-</span>
            </template>
        </el-table-column>
     </el-table>

     <div class="table-footer">

        <el-pagination
          class="paging"
          v-if="allPages>1"
          @current-change="pageChange"
          :current-page="params.no"
          :page-size="params.size"
          layout="total, prev, pager, next, jumper"
          :total="params.allEls">
        </el-pagination>

    </div>

  </div>

</div>

</template>

<script>
import { getBuildings } from '@/api/industryInfos';
export default {
   data(){
      return{
          tbData:[],
          navArr:['全部','初审通过','通过'],
          navAct:0,

          allPages:0,
          params:{
              status:'2,1',
              no:1,
              size:10,
              allEls:0
          },
      }
   },
   filters:{
      statusTrans(e){
          let arr=['','初审通过','通过','','',''];
          return arr[e];
      }
    },
   methods:{

     pageChange(e){
        this.params.no = e;
        this.getList();
     },

     navChange(inx){
        this.navAct = inx;
        if(inx === 0){
           this.params.status = '2,1';
        }else if(inx===1){
           this.params.status = '1';
        }else if(inx===2){
           this.params.status = '2';
        }
        this.reList();
     },

     getList(){
         this.loading = true;
         getBuildings(this.params).then(res => {
             this.loading = false;
             this.tbData = res.industrialSpaceList;
             this.params.allEls = res.totalElements;
             this.allPages = res.totalPages;
         })
     },

     reList:function(){
         this.params.no = 1;
         this.getList();
     },

     goInner(id,type){
        //  type  1 查看 2 审核
        //vtype 1街乡审核2发改审核
        this.$router.push({
             path:'bulidingInfos',
             query:{
                 id,
                 type,
                 vtype:2,
             }
        })
     }
   },

   created(){
     this.getList();
   }
}
</script>

<style lang="scss" scoped>

#buildingVerificate{
  .headLine{
      padding: 0 20px;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #EBEEF5;
  }

  .navLine{
     padding-left: 20px;
     border-bottom: 1px solid #EBEEF5;
     .navItem{
         height: 54px;
         font-size: 14px;
         margin: 0 30px;
         display: inline-block;
         line-height: 54px;
         border-bottom: 2px solid white;
         cursor: pointer;
         &.act{
            color: #409EFF;
            border-color: #409EFF;
         }
     }
  }

  .pgContent{
      padding: 30px;
      .ibtn{
          cursor: pointer;
          font-size: 13px;
          color: #409EFF;
      }

      .table-footer{
          margin-top: 20px;
          text-align: right;
      }
  }

}

</style>



// WEBPACK FOOTER //
// index.vue?fecfb976